import { NavLink, Outlet, useParams } from "react-router-dom";

const ChurchLayout = () => {
  const { churchId } = useParams();

  return (
    <>
      <nav>
        <NavLink to="edit"></NavLink>
        <NavLink to="baptism/new_event"></NavLink>
        <NavLink to="baptism/:baptismId/manage"></NavLink>
      </nav>
      <main>
        <Outlet context={[churchId]} />
      </main>
    </>
  );
};

export default ChurchLayout;
